module.exports = __webpack_public_path__ + "static/media/hw_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/CertificatePage/img/hw_logo.jpg
// module id = 569
// module chunks = 0